class DeleteAccount extends FormValidation {
    constructor() {
        super();
        this.accountDrawer = document.querySelector('account-drawer');
        this.deleteForm = this.querySelector('form');
        this.checkbox = this.querySelector("input[type='checkbox'][name='customer[remove]']");
        this.globalMessage = this.querySelector('.global-message');
        this.globalMessageCopy = this.querySelector('.global-message__copy');
        this.targetDrawer = this.deleteForm.closest('.drawer__inner');
        this.fadeOutTimeout = null;
    }

    connectedCallback() {
        this.setupEventListeners();
    }

    setupEventListeners() {
        this.deleteForm.addEventListener('submit', this.formSubmit.bind(this));
    }
    formSubmit(event) {
        event.preventDefault();
        if (!this.hasValidated) return;
        this.handleAccountDeletion();
    }

    handleAccountDeletion() {
        this.accountDrawer.toggleLoading();
        fetch(getGlobalDomain(`/apps/bat-enhanced/customer/delete`), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: this.checkbox.value,
            }),
        })
            .then((response) => {
                if (!response.ok) throw new Error('Network response was not ok.');
                return response.json();
            })
            .then((response) => {
                setTimeout(() => {
                    sessionStorage.clear();
                    window.location.href = window.routes.logout;
                    this.accountDrawer.toggleLoading();
                }, 1500);
            })
            .catch((error) => {
                console.error('Error:', error);
                this.displayMessage(false, window.validationStrings.genericError);
                this.accountDrawer.toggleLoading();
            });
    }

    displayMessage(isSuccess, message) {
        clearTimeout(this.fadeOutTimeout);

        this.globalMessage.classList.remove(
            'global-message--success',
            'global-message--error',
            'global-message--fade-out'
        );
        this.globalMessage.classList.add(isSuccess ? 'global-message--success' : 'global-message--error');
        this.globalMessageCopy.textContent = message;

        this.globalMessage.style.display = 'flex';
        this.globalMessage.style.opacity = 1;

        this.fadeOutTimeout = setTimeout(() => {
            this.globalMessage.classList.add('global-message--fade-out');
            setTimeout(() => {
                this.globalMessage.style.display = 'none';
            }, 500);
        }, 2000);
    }
}

customElements.define('delete-account', DeleteAccount);
